<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-11-04 15:03:04
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-04 09:31:50
-->
<template>
  <div class="info-div">
    <div class="info-body">
      <el-button type="primary" @click="edit()" style="float: right"
        >编辑</el-button
      >
      <!-- <section class="flex">
        <div style="margin-right: 20px">企业风采</div>
        <div
          v-for="item in entInfo.videoList"
          :key="item.ossUrl"
          style="margin-right: 20px"
        >
          <video :src="item.ossUrl" class="avatar" controls="controls">
            您的浏览器不支持视频播放
          </video>
        </div>
        <div
          v-for="item in entInfo.pictures"
          :key="item.ossUrl"
          style="margin-right: 20px"
        >
          <img :src="item.ossUrl" style="width: 180px" />
        </div>
      </section> -->
      <section class="flex entInfoBox">
        <div>
          <span class="label"> 联系电话：</span>
          {{ entInfo.entTel || '-' }}
        </div>
        <div>
          <span class="label">公司邮箱：</span>
          {{ entInfo.entMail || '-' }}
        </div>
        <div>
          <span class="label">网址：</span>
          {{ entInfo.entWeb || '-' }}
        </div>
        <div>
          <span class="label">经办人姓名：</span>{{ entInfo.jbrName || '-' }}
        </div>
        <div>
          <span class="label">财务姓名：</span
          >{{ entInfo.financialName || '-' }}
        </div>
        <div>
          <span class="label">人事姓名：</span
          >{{ entInfo.personnelName || '-' }}
        </div>
        <div>
          <span class="label">经办人电话：</span>{{ entInfo.jbrTel || '-' }}
        </div>

        <div>
          <span class="label">财务电话：</span>{{ entInfo.financialTel || '-' }}
        </div>
        <div>
          <span class="label">人事电话：</span>{{ entInfo.personnelTel || '-' }}
        </div>
        <div>
          <span class="label">所在区域：</span>
          {{ entInfo.province }}{{ entInfo.city }}{{ entInfo.county }}
        </div>
        <div>
          <span class="label"> 办公地址：</span>
          {{ entInfo.workAddress || '-' }}
        </div>
        <div>
          <span class="label">企业类型：</span>
          {{ entInfo.entType || '-' }}
        </div>
        <div>
          <span class="label">企业规模：</span>
          {{ entInfo.entScale || '-' }}
        </div>
        <div>
          <span class="label">企业占地面积：</span>
          {{ entInfo.landArea }}平方米
        </div>
      </section>
      <section class="flex">
        <div class="briefBox">
          <span class="label">公司简介：</span>{{ entInfo.brief || '-' }}
        </div>
      </section>
      <section class="flex entInfoBox">
        <div>
          <span class="label">从业人数：</span>{{ entInfo.workNumber || '-' }}人
        </div>
        <div>
          <span class="label">行政人员人数：</span
          >{{ entInfo.adminNumber || '-' }}人
        </div>
        <div>
          <span class="label">研发人员人数：</span
          >{{ entInfo.researchNumber || '-' }}人
        </div>
        <div>
          <span class="label">博士人数：</span>{{ entInfo.phNumber || '-' }}人
        </div>
        <div>
          <span class="label">硕士人数：</span
          >{{ entInfo.masterNumber || '-' }}人
        </div>
        <div>
          <span class="label">本科人数：</span
          >{{ entInfo.courseNumber || '-' }}人
        </div>
      </section>
      <section class="fileListBox">
        <div class="label">从业人数证明：（点击预览）</div>
        <div
          class="fileList"
          v-if="entInfo.proveFiles && entInfo.proveFiles.length"
        >
          <div
            class="fileList-item"
            v-for="(item, index) in entInfo.proveFiles"
            :key="index"
            @click="viewFile(item)"
          >
            {{ item.fileName }}
          </div>
        </div>
        <div v-else>暂无数据</div>
      </section>
      <!-- <section class="fileListBox">
        <div class="label">荣誉资质：</div>
        <div
          class="fileList"
          v-if="entInfo.honorFiles && entInfo.honorFiles.length"
        >
          <img
            class="fileList-item"
            :src="item.ossUrl"
            v-for="(item, index) in entInfo.honorFiles"
            :key="index"
            :alt="item.fileName"
          />
        </div>
        <div v-else>暂无数据</div>
      </section> -->
      <section class="fileListBox">
        <div class="label">营业执照：</div>
        <div
          class="fileList"
          v-if="entInfo.licenseFiles && entInfo.licenseFiles.length"
        >
          <img
            class="fileList-item"
            :src="item.ossUrl"
            v-for="(item, index) in entInfo.licenseFiles"
            :key="index"
            :alt="item.fileName"
          />
        </div>
        <div v-else>暂无数据</div>
      </section>
    </div>
    <el-dialog
      title="编辑企业信息"
      :visible.sync="dialogVisible"
      width="68%"
      @closed="handleClose"
    >
      <div>
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          label-width="120px"
          label-position="right"
          :rules="rules"
        >
          <!-- <el-col :span="24">
            <el-form-item label="视频上传" prop="Video">
              <div style="display: inline-flex">
                <div
                  v-for="(item, index) in ruleForm.videoList"
                  :key="item.ossUrl"
                  style="margin-right: 10px; position: relative"
                >
                  <video :src="item.ossUrl" class="avatar" controls="controls">
                    您的浏览器不支持视频播放
                  </video>
                  <i
                    class="del-img el-icon-close"
                    @click="forkImage(index)"
                  ></i>
                </div>
                <div
                  v-for="(item, index) in ruleForm.pictures"
                  :key="item.ossUrl"
                  style="margin-right: 10px; position: relative"
                >
                  <img :src="item.ossUrl" alt="" style="width: 180px" />
                  <i
                    class="del-img el-icon-close"
                    @click="newforkImage(index)"
                  ></i>
                </div>
                <el-progress
                  v-if="videoFlag"
                  type="circle"
                  :percentage="videoUploadPercent"
                  style="margin-top: 30px"
                ></el-progress>
                <el-upload
                  class="avatar-uploader el-upload--text"
                  :action="uploadImg"
                  list-type="picture-card"
                  :headers="uploadHeader"
                  :show-file-list="false"
                  :on-success="handleVideoSuccess"
                  :before-upload="beforeUploadVideo"
                  :on-progress="uploadVideoProcess"
                  accept=".mp4, .avi, .mov,m4v,mkv,fiv,wmv,.jpg, .png, .jpeg"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>

              <div class="text">
                请保证视频格式正确，且不超过50M，数量最多不超过5个
              </div>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="联系电话：" prop="entTel">
              <el-input
                v-model="ruleForm.entTel"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公司邮箱：" prop="createBy">
              <el-input
                v-model="ruleForm.entMail"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="网址：" prop="entWeb">
              <el-input
                v-model="ruleForm.entWeb"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所在区域：" prop="entAddress">
              <!-- <el-input v-model="ruleForm.entAddress" placeholder="请输入"></el-input> -->
              <el-cascader
                v-model="ruleForm.entAddress"
                :options="areaList"
                :props="{ label: 'text', value: 'value' }"
                clearable
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="办公地址：" prop="workAddress">
              <el-input
                v-model="ruleForm.workAddress"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业类型：" prop="entType">
              <el-input
                v-model="ruleForm.entType"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业规模：" prop="entScale">
              <el-input
                v-model="ruleForm.entScale"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="占地面积：" prop="landArea">
              <el-input
                type="number"
                v-model.number="ruleForm.landArea"
                placeholder="请输入，单位平方米"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="公司简介：" prop="content">
              <el-input
                type="textarea"
                v-model="ruleForm.brief"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="经办人姓名：" prop="smsTypes">
              <el-input
                v-model="ruleForm.jbrName"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="经办人电话：" prop="jbrTel">
              <el-input
                v-model="ruleForm.jbrTel"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="财务姓名：" prop="smsTypes">
              <el-input
                v-model="ruleForm.financialName"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="财务电话：" prop="financialTel">
              <el-input
                v-model="ruleForm.financialTel"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="人事姓名：" prop="smsTypes">
              <el-input
                v-model="ruleForm.personnelName"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="人事电话：" prop="telephone">
              <el-input
                v-model="ruleForm.personnelTel"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="从业人数：" prop="workNumber">
              <el-input
                type="number"
                v-model="ruleForm.workNumber"
                placeholder="请输入，单位人"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="行政人员人数：" prop="adminNumber">
              <el-input
                type="number"
                v-model="ruleForm.adminNumber"
                placeholder="请输入，单位人"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="研发人员人数：" prop="researchNumber">
              <el-input
                type="number"
                v-model="ruleForm.researchNumber"
                placeholder="请输入，单位人"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="博士人数：" prop="phNumber">
              <el-input
                type="number"
                v-model="ruleForm.phNumber"
                placeholder="请输入，单位人"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="本科人数：" prop="courseNumber">
              <el-input
                type="number"
                v-model="ruleForm.courseNumber"
                placeholder="请输入，单位人"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="硕士人数：" prop="masterNumber">
              <el-input
                type="number"
                v-model="ruleForm.masterNumber"
                placeholder="请输入，单位人"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" class="">
            <el-form-item label="从业人数证明：" prop="masterNumber">
              <el-upload
                class="upload-demo"
                :action="uploadImg"
                :on-remove="handleRemove"
                :headers="uploadHeader"
                multiple
                :limit="5"
                :on-exceed="handleExceed"
                :file-list="fileList"
                :on-success="docSuccess"
              >
                <el-button size="small">
                  <i class="el-icon-upload2"></i>点击上传</el-button
                >
                <div slot="tip" class="el-upload__tip">
                  支持doc，docx，xls，xlsx，png，jpg，pdf等格式，数量最多5个
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="24" class="">
            <el-form-item label="荣誉资质：" prop="masterNumber">
              <el-upload
                class="avatar-uploader el-upload--text"
                :action="uploadImg"
                list-type="picture-card"
                :headers="uploadHeader"
                :file-list="honoraryFileList"
                :on-remove="handleRemoveHonorary"
                :on-success="handleHonorarySuccess"
                :before-upload="beforeUploadImg"
                :limit="5"
                :on-exceed="handleExceed"
                accept=".jpg, .png, .jpeg"
              >
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">
                  支持上传PNG,JPG格式的图片最多不超过5个
                </div>
              </el-upload>
            </el-form-item>
          </el-col> -->
          <el-col :span="24" class="">
            <el-form-item label="营业执照：" prop="masterNumber">
              <el-upload
                class="avatar-uploader el-upload--text"
                :action="uploadImg"
                list-type="picture-card"
                :headers="uploadHeader"
                :file-list="licenseFileList"
                :on-remove="handleRemoveLicense"
                :on-success="handleLicenseSuccess"
                :limit="5"
                :on-exceed="handleExceed"
                :before-upload="beforeUploadImg"
                accept=".jpg, .png, .jpeg"
              >
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">
                  支持上传PNG,JPG格式的图片最多不超过5个
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-image-viewer
      v-if="showImgView"
      :on-close="
        () => {
          showImgView = false
        }
      "
      :url-list="[exhibitImg]"
    />
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { uploadImg } from '@api/video/liveOperation'
import {
  getAreaList,
  insertOrUpdateEntDetail,
  insertOrUpdateEntDetailByAdmin,
  uploadVideo
} from '@api/corporateInteraction/enterprise'
import { toHtmlStr, getToken, isHttp, isPhone } from '@utils'
export default {
  name: 'CorporateStyle',
  data() {
    return {
      videoFlag: false,
      videoUploadPercent: 0,
      uploadHeader: {
        Authorization: 'Bearer ' + getToken()
      },
      uploadImg,
      uploadVideo,
      toHtmlStr,
      dialogVisible: false,
      ruleForm: {
        proveFiles: [],
        HonorFiles: [],
        licenseFiles: []
      },
      rules: {
        entAddress: [
          { required: true, message: '请选择地区', trigger: 'change' }
        ],
        entTel: isPhone(),
        jbrTel: isPhone(),
        financialTel: isPhone(),
        entWeb: {
          pattern: /^(http|https)\S*/,
          message: '开头必须是http或者https',
          trigger: 'blur'
        }
      },
      fileList: [],
      honoraryFileList: [],
      licenseFileList: [],
      areaList: [], // 地址
      showImgView: false,
      exhibitImg: ''
    }
  },
  components: { ElImageViewer },
  props: {
    entInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    entInfo: {
      handler(val) {
        // console.log(Object.keys(val).length)
        this.ruleForm = JSON.parse(JSON.stringify(val))
        if (this.ruleForm.proveFiles && this.ruleForm.proveFiles.length) {
          this.fileList = []
          this.ruleForm.proveFiles.map((item) => {
            this.fileList.push({ name: item.fileName, url: item.ossUrl })
          })
        } else {
          this.ruleForm.proveFiles = []
        }
        if (this.ruleForm.honorFiles && this.ruleForm.honorFiles.length) {
          this.honoraryFileList = []
          this.ruleForm.honorFiles.map((item) => {
            this.honoraryFileList.push({
              name: item.fileName,
              url: item.ossUrl
            })
          })
        } else {
          this.ruleForm.honorFiles = []
        }
        if (this.ruleForm.licenseFiles && this.ruleForm.licenseFiles.length) {
          this.licenseFileList = []
          this.ruleForm.licenseFiles.map((item) => {
            this.licenseFileList.push({ name: item.fileName, url: item.ossUrl })
          })
        } else {
          this.ruleForm.licenseFiles = []
        }
      },
      deep: true // 深度监听父组件传过来对象变化
    }
  },
  computed: {},
  created() {
    // this.ruleForm = this.entInfo
    this.getAreaList()
  },
  methods: {
    /** 编辑企业主页 */
    edit() {
      this.dialogVisible = true
    },
    /** 获取地址 */
    getAreaList() {
      getAreaList({}).then((res) => {
        if (res.data.code == '0000') {
          this.areaList = res.data.data || []
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    beforeUploadVideo(file) {
      const isLt10M = file.size / 1024 / 1024 < 50
      if (
        [
          'video/mp4',
          'video/ogg',
          'video/flv',
          'video/avi',
          'video/wmv',
          'video/rmvb',
          'image/png',
          'image/jpg',
          'image/jpeg'
        ].indexOf(file.type) == -1
      ) {
        this.$message.error('请上传正确的视频格式')
        return false
      }
      if (!isLt10M) {
        this.$message.error('上传视频大小不能超过50MB哦!')
        return false
      }
      const num = this.ruleForm.videoList.length + this.ruleForm.pictures.length
      if (num >= 5) {
        this.$message.error('当前上传文件已达到数量限制')
        return false
      }
    },
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true
      this.videoUploadPercent = Number(file.percentage.toFixed(0))
    },
    handleVideoSuccess(res, file) {
      // 获取上传图片地址
      this.videoFlag = false
      this.videoUploadPercent = 0
      if (res.code == '0000') {
        if (['png', 'jpg', 'jpeg'].indexOf(res.data.ext) !== -1) {
          this.ruleForm.pictures.push({
            fileName: res.data.fileName,
            ossUrl: res.data.ossUrl
          })
        } else {
          this.ruleForm.videoList.push({
            fileName: res.data.fileName,
            ossUrl: res.data.ossUrl
          })
        }
      } else {
        this.$message.error('视频上传失败，请重新上传！')
      }
    },
    forkImage(index) {
      this.ruleForm.videoList.splice(index, 1)
    },
    newforkImage(index) {
      this.ruleForm.pictures.splice(index, 1)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.province = this.ruleForm.entAddress[0]
          this.ruleForm.city = this.ruleForm.entAddress[1]
          this.ruleForm.county = this.ruleForm.entAddress[2]
          console.log(this.ruleForm, this.ruleForm.proveFiles, '编辑企业信息')
          let data = { ...this.ruleForm }
          delete data.entAddress
          if(this.$store.state.user.userInfo.roleText == '系统管理员') {
            insertOrUpdateEntDetailByAdmin(data).then((res) => {
              if (res.data.code == '0000') {
                this.$message.success(res.data.msg)
                this.dialogVisible = false
                this.$emit('fatherMethod')
                // this.dialogVisible = false
                // this.listEnt()
              } else {
                this.$message.error(res.data.msg)
              }
            })
          } else {
            insertOrUpdateEntDetail(data).then((res) => {
              if (res.data.code == '0000') {
                this.$message.success(res.data.msg)
                this.dialogVisible = false
                this.$emit('fatherMethod')
                // this.dialogVisible = false
                // this.listEnt()
              } else {
                this.$message.error(res.data.msg)
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    /** 关闭联系企业清空弹窗 */
    handleClose() {
      this.ruleForm = JSON.parse(JSON.stringify(this.entInfo))
    },
    // 上传文件证明
    docSuccess(response, file, fileList) {
      if (response.code == '0000') {
        this.ruleForm.proveFiles.push(response.data)
      }
    },
    handleRemove(file, fileList) {
      const index = this.ruleForm.proveFiles.findIndex((item) => {
        return item.id == file.id
      })
      this.ruleForm.proveFiles.splice(index, 1)
    },
    handleExceed(files, fileList) {
      this.$message.warning('当前限制选择 5 个文件，已上传了5个文件')
    },
    viewFile(item) {
      const url = item.ossUrl
      // pdf 和图片 预览，其他都下载
      const urlSuffixType = url.split('.')
      const urlType = urlSuffixType[urlSuffixType.length - 1]
      if (['png', 'jpg'].includes(urlType.toLowerCase())) {
        this.exhibitImg = url
        this.showImgView = true
        return
      }
      const openType = ['pdf'].includes(urlType.toLowerCase())
        ? '_blank'
        : '_self'
      window.open(url, openType)
    },
    // 荣誉资质和营业执照
    handleHonorarySuccess(response, file, fileList) {
      if (response.code == '0000') {
        this.ruleForm.honorFiles.push(response.data)
      }
    },
    handleLicenseSuccess(response, file, fileList) {
      if (response.code == '0000') {
        this.ruleForm.licenseFiles.push(response.data)
      }
    },
    beforeUploadImg(file) {
      if (['image/png', 'image/jpg', 'image/jpeg'].indexOf(file.type) == -1) {
        this.$message.error('请上传正确的图片格式')
        return false
      }
    },
    handleRemoveHonorary(file, fileList) {
      const index = this.ruleForm.honorFiles.findIndex((item) => {
        return item.id == file.id
      })
      this.ruleForm.honorFiles.splice(index, 1)
    },
    handleRemoveLicense(file, fileList) {
      const index = this.ruleForm.licenseFiles.findIndex((item) => {
        return item.id == file.id
      })
      this.ruleForm.licenseFiles.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__wrapper {
  .el-dialog__header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.3);
  }
  .el-dialog__body {
    padding: 30px 60px 20px;
    font-size: 16px;
    height: 650px !important;
    overflow: auto;
  }
  .el-dialog__footer {
    border-top: 1px solid rgba(0, 0, 0, 0.3);
  }
}
.avatar {
  width: 180px;
  height: 180px;
}
.del-img {
  font-size: 20px;
  position: absolute;
  cursor: pointer;
  top: 0;
  right: 0;
  z-index: 999;
}
.flex {
  display: flex !important;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
  .briefBox {
    margin-bottom: 20px;
  }
  .label {
    color: rgba(0, 0, 0, 0.8);
  }
}
.entInfoBox {
  flex-wrap: wrap;
  > div {
    width: 33.3%;
    margin-bottom: 20px;
  }
}
.fileListBox {
  display: flex;
  margin-bottom: 20px;
  .label {
    color: rgba(0, 0, 0, 0.8);
  }
  .fileList {
    display: flex;
    width: 80%;
    flex-wrap: wrap;
    &-item {
      cursor: pointer;
      width: 25%;
      color: #1890ff;
    }
    img {
      width: 180px;
      height: 180px;
      margin-right: 20px;
    }
  }
}
</style>
